<template>
  <div class="d-flex justify-start align-center pt-6">
    <ConfirmAssignDialog
      :state="confirmStudentDialog"
      :importedDocuments="importedDocuments"
      @closeDialog="closeConfirmDialog"
      @updateResult="onUpdateResultDocument"
      ref="assignDialog"
    />
    <InvalidRoomDialog :invalidRooms="invalidRooms" :state="invalidDialog" @closeDialog="closeInvalid" />
    <AssignAllExamCodeDialog :exam="exam" @closeDialog="closeIndexingStudent" @refresh="refresh" />
    <AssignEmptyExamCodeDialog :exam="exam" @closeDialog="closeIndexingEmpty" @refresh="refresh" />
    <AssignAllRoomsDialog :state="asignAllRooms" :exam="exam" @closeDialog="closeAllRooms" @refresh="refresh" />
    <!-- <AssignRoomEmptyDialog :state="emptyRooms" :exam="exam" @closeDialog="closeEmptyRooms" @refresh="refresh" /> -->
    <IndexingAllDialog :state="assignAllDialog" :exam="exam" @closeDialog="closeIndexingStudent" @refresh="refresh" />
    <IndexingEmptyDialog :state="assignEmptyDialog" :exam="exam" @closeDialog="closeIndexingEmpty" @refresh="refresh" />
    <div>
      <v-menu open-on-hover bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mt-0 ml-6" color="green" dark v-bind="attrs" v-on="on" outlined>
            Nhập/xuất Excel xếp phòng
          </v-btn>
        </template>

        <v-list>
          <v-list-item class="cursor-pointer">
            <v-list-item-title @click="onUploadClick">Tải lên tệp Excel chứa thông tin xếp phòng</v-list-item-title>
            <input
              ref="uploader"
              type="file"
              class="d-none"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              @change="onFileChanged"
            />
          </v-list-item>
          <v-list-item class="cursor-pointer">
            <v-list-item-title @click="exportListDataToExcel">Tải xuống tệp Excel danh sách học sinh</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <ExportStudentList :exam="exam" />
    <v-spacer></v-spacer>
    <div>
      <v-menu open-on-hover bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mt-0 ml-6 " color="primary" dark v-bind="attrs" v-on="on" outlined>
            Đánh S.B.D tự động
          </v-btn>
        </template>

        <v-list>
          <v-list-item class="cursor-pointer">
            <v-list-item-title @click="indexingEmpty">Đánh số học sinh chưa đánh</v-list-item-title>
          </v-list-item>
          <v-list-item class="cursor-pointer">
            <v-list-item-title @click="indexingStudent">Đánh số toàn bộ học sinh</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu open-on-hover bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mt-0 ml-6 mr-6" color="primary" dark v-bind="attrs" v-on="on" outlined>
            Xếp phòng thi tự động
          </v-btn>
        </template>

        <v-list>
          <v-list-item class="cursor-pointer">
            <v-list-item-title @click="autoAssingRooms">Xếp toàn bộ học sinh</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item class="cursor-pointer">
            <v-list-item-title @click="autoAssignRoomsEmpty">Xếp học sinh chưa xếp</v-list-item-title>
          </v-list-item> -->
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { mapActions, mapGetters } from 'vuex'
import readXlsxFile from 'read-excel-file'
import XLSX from 'xlsx-js-style'

import ConfirmAssignDialog from './ConfirmAssignDialog.vue'
import { StudentExam } from '@/plugins/api'
import InvalidRoomDialog from './InvalidRoomDialog.vue'
import AssignAllExamCodeDialog from './AssignAllExamCodeDialog.vue'
import AssignEmptyExamCodeDialog from './AssignEmptyExamCodeDialog.vue'
import AssignAllRoomsDialog from './AssignAllRoomsDialog.vue'
// import AssignRoomEmptyDialog from './AssignRoomEmptyDialog.vue'
import IndexingAllDialog from './IndexingAllDialog.vue'
import IndexingEmptyDialog from './IndexingEmptyDialog.vue'
import moment from 'moment'
import ExportStudentList from './ExportStudentList.vue'

const schema = {
  'Họ tên': {
    prop: 'name',
    type: String,
    required: true
  },
  'Mã định danh Bộ GD&ĐT': {
    prop: 'code_short',
    type: String,
    required: true
  },
  'Số báo danh': {
    prop: 'examCode',
    type: String
  },
  'Phòng thi': {
    prop: 'rooms',
    type: String
  }
}
export default {
  components: {
    ConfirmAssignDialog,
    InvalidRoomDialog,
    AssignAllExamCodeDialog,
    AssignEmptyExamCodeDialog,
    AssignAllRoomsDialog,
    // AssignRoomEmptyDialog,
    IndexingAllDialog,
    IndexingEmptyDialog,
    ExportStudentList
  },
  props: {
    exam: String,
    query: Object
  },
  data() {
    return {
      dialog: false,
      students: null,
      confirmStudentDialog: false,
      isSelecting: false,
      invalidDialog: false,
      assignAllDialog: false,
      assignEmptyDialog: false,
      emptyRooms: false,
      asignAllRooms: false,
      invalidRooms: '',
      importedDocuments: [],
      json_list_fields: {
        STT: 'index',
        'Mã định danh Bộ GD&ĐT': 'student.code_short',
        'Số báo danh': 'examCode',
        'Họ tên': 'student.name',
        'Ngày sinh': 'student.dob',
        'Giới tính': 'student.gender',
        Lớp: 'class.title',
        'Phòng thi': 'rooms',
        'Mã đề': '',
        'Số tờ': '',
        'Kí tên': '',
        'Ghi chú': ''
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'isAuthenticated'])
  },
  methods: {
    ...mapActions('studentExam', ['fetchStudentExams']),
    onUploadClick() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },

    async getStudentExcel() {
      this.$loading.active = true
      const students = await this.fetchStudentExams({
        exam: this.exam,
        ...this.query,
        _sort: 'examCode:asc',
        _limit: -1
      })
      this.students = students
      this.$loading.active = false
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema,
          transformData(rows) {
            return rows.slice(7)
          }
        })
      } catch (error) {
        console.error(error)
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      this.$alert.success('Đã đọc File thành công!')
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const data = readFileResult.rows
        this.importedDocuments = data
        this.confirmStudentDialog = true
      }
      this.$loading.active = false
    },
    formatListDataForExport(data) {
      return data.map((item, index) => {
        let formattedItem = {}
        for (let key in this.json_list_fields) {
          const fieldPath = this.json_list_fields[key]
          let value = item

          // Traverse the field path to get the value
          if (typeof fieldPath === 'string') {
            const pathParts = fieldPath.split('.')
            pathParts.forEach(part => {
              value = value ? value[part] : '' // Set value to '' if it's undefined/null
            })
          }

          // Handle date formatting
          if ((key === 'Ngày sinh' || key === 'Ngày tạo') && value) {
            value = moment(value).format('DD/MM/YYYY')
          }

          // Handle gender formatting
          if (key === 'Giới tính' && value) {
            value = value === 'male' ? 'Nam' : 'Nữ'
          }
          if (key === 'Phòng thi' && value && value.length) {
            value = value.map(room => room.code).join(', ')
          }
          // Add the STT value based on the index
          if (key === 'STT') {
            value = index + 1 // STT starts from 1
          }

          formattedItem[key] = value !== undefined && value !== null ? value : ''

          // Handle special case for 'Số báo danh'
          if (key === 'Số báo danh' && value) {
            formattedItem[key] = { v: value, t: 's' }
          }
        }
        return formattedItem
      })
    },
    async exportListDataToExcel() {
      await this.getStudentExcel()
      const formattedData = this.formatListDataForExport(this.students)
      const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true })
      const headers = [
        ['SỞ GIÁO DỤC VÀ ĐÀO TẠO HÀ NỘI', ''], // Header 1
        ['TRƯỜNG THCS VÀ THPT CSP*', ''], // Header 2
        ['', ''],
        ['DANH SÁCH HỌC SINH KIỂM TRA', ''], // Header 4
        ['NĂM HỌC 2024 - 2025', ''], // Header 5
        ['', ''],
        ['', '']
      ]
      headers.forEach((header, rowIndex) => {
        const cellAddress = `A${rowIndex + 1}`
        worksheet[cellAddress] = { v: header[0], t: 's' }

        if (rowIndex === 0 || rowIndex === 1) {
          worksheet[cellAddress].s = {
            font: { bold: true, sz: 13, name: 'Times New Roman' },
            alignment: { horizontal: 'left', vertical: 'center' }
          }
        }

        if (rowIndex === 3 || rowIndex === 4) {
          worksheet[cellAddress].s = {
            font: { bold: true, sz: 17, name: 'Times New Roman' },
            alignment: { horizontal: 'center', vertical: 'center' }
          }
        }
      })

      // Define merges for the headers
      worksheet['!merges'] = [
        { s: { r: 3, c: 0 }, e: { r: 3, c: 13 } },
        { s: { r: 4, c: 0 }, e: { r: 4, c: 13 } },
        { s: { r: 5, c: 0 }, e: { r: 5, c: 13 } }
      ]

      // Define common styles for headers and data cells
      const headerStyle = {
        font: { bold: true, sz: 12, name: 'Times New Roman' },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' }
        }
      }

      const dataStyle = {
        font: { sz: 12, name: 'Times New Roman' },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' }
        }
      }

      // Add the actual table data starting from A8
      XLSX.utils.sheet_add_json(worksheet, formattedData, {
        origin: 'A8',
        header: this.getHeaders(),
        skipHeader: false
      })

      // Apply styles to the headers (row 8)
      this.getHeaders().forEach((header, colIndex) => {
        const colLetter = String.fromCharCode(65 + colIndex) // Convert column index to letter (A, B, C, ...)
        const headerCellAddress = `${colLetter}8`

        // Ensure the header cell exists before applying styles
        if (worksheet[headerCellAddress]) {
          worksheet[headerCellAddress].s = headerStyle // Apply header style
        }

        // Apply data style to each data row only if data is available
        if (formattedData.length > 0) {
          for (let rowIndex = 9; rowIndex < formattedData.length + 9; rowIndex++) {
            const dataCellAddress = `${colLetter}${rowIndex}`

            // Ensure the data cell exists before applying styles
            if (worksheet[dataCellAddress]) {
              worksheet[dataCellAddress].s = dataStyle
            }
          }
        }
      })

      // If there is no data, apply the border to just the first row after headers
      if (formattedData.length === 0) {
        this.getHeaders().forEach((header, colIndex) => {
          const colLetter = String.fromCharCode(65 + colIndex) // Convert column index to letter (A, B, C, ...)
          const dataCellAddress = `${colLetter}9`

          worksheet[dataCellAddress] = { v: '', t: 's' }
          worksheet[dataCellAddress].s = headerStyle // Apply header style to the first row after headers
        })
      }
      this.setColumnWidths(worksheet, formattedData)

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Students')

      XLSX.writeFile(workbook, 'danh-sach-hoc-sinh.xlsx')
      this.$loading.active = false
    },
    async onUpdateResultDocument(data) {
      this.$refs.uploader.value = null
      const updateData = {
        exam: this.exam,
        assignments: data
      }
      const assigned = await StudentExam.assignRooms(updateData)
      if (!assigned.unfoundRoomNames) {
        this.closeConfirmDialog()
        this.$emit('refresh')
      } else {
        this.$refs.assignDialog.stopLoading()
        this.invalidRooms = assigned.unfoundRoomNames
        this.invalidDialog = true
      }
    },
    closeInvalid() {
      this.invalidDialog = false
      this.invalidRooms = ''
    },
    setColumnWidths(worksheet, data) {
      let maxWidths = []
      const columnNames = data.length > 0 ? Object.keys(data[0]) : []

      columnNames.forEach((name, index) => {
        maxWidths[index] = name.length
      })

      data.forEach(row => {
        columnNames.forEach((name, index) => {
          const value = (row[name] || '').toString().trim()
          maxWidths[index] = Math.max(maxWidths[index], value.length)
        })
      })

      worksheet['!cols'] = maxWidths.map((width, index) => {
        if (columnNames[index] === 'id') {
          return { width, hidden: true }
        }
        return { width }
      })
    },
    getHeaders() {
      const headers = []
      for (let key in this.json_list_fields) {
        headers.push(key)
      }
      return headers
    },
    closeConfirmDialog() {
      this.isSelecting = false
      this.confirmStudentDialog = false
      this.$refs.uploader.value = null
    },
    autoAssingRooms() {
      this.asignAllRooms = true
    },
    closeAllRooms() {
      this.asignAllRooms = false
    },
    autoAssignRoomsEmpty() {
      this.emptyRooms = true
    },
    closeEmptyRooms() {
      this.emptyRooms = false
    },
    indexingStudent() {
      this.assignAllDialog = true
    },
    closeIndexingStudent() {
      this.assignAllDialog = false
    },
    indexingEmpty() {
      this.assignEmptyDialog = true
    },
    closeIndexingEmpty() {
      this.assignEmptyDialog = false
    },
    refresh() {
      this.$emit('refresh')
    }
  }
}
</script>
